import { Component, Injector, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { SearchAndSelect } from "../components/form/models/serachselect.model";
import { UiEngineComponent } from "../components/ui-engine/ui-engine.component";

@Component({
    selector: "app-template-reports",
    templateUrl: "./template-reports.component.html",
    styleUrls: ["./template-reports.component.scss"],
    standalone: false
})
export class TemplateReportsComponent
  extends UiEngineComponent
  implements OnInit
{
  currentData: any = {};
  @Input() input: any;

  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public modal: BsModalService
  ) {
    super(injector, router, route, modal);
  }

  ngOnInit(): void {
    if (this.input && this.input == "template_assessment_mis") {
      this.currentData.templatedatasource = {
        application: "form-template-engine",
        resource: "template",
        query_id: "GET_SYSTEM_TEMPLATE_ACCOUNT_ID",
      };
      this.currentData.template_key = "template_id";
      this.currentData.templatedatasource["args"] =
        "templateType:template_assessment";
      this.currentData.templatedatasource["filter"] =
        "templateType:template_assessment";
    } else if (this.input && this.input == "health_assessment_mis") {
      this.currentData.templatedatasource = {
        application: "form-template-engine",
        resource: "template",
        query_id: "GET_SYSTEM_TEMPLATE_ACCOUNT_ID",
        filter: "templateType:assessment_score,status:active",
      };
      this.currentData.template_key = "template_id";
      this.currentData.templatedatasource["args"] =
        "templateType:assessment_score,status:active";
      this.currentData.templatedatasource["filter"] =
        "templateType:assessment_score,status:active";
    } else if (this.input && this.input == "mis_op_feedback_report") {
      this.currentData.templatedatasource = {
        application: "form-template-engine",
        resource: "template",
        query_id: "GET_SYSTEM_TEMPLATE_ACCOUNT_ID",
        filter: "templateType:feedback_form,status:active,patientType.id:OP",
      };
      this.currentData.template_key = "templateId";
      this.currentData.templatedatasource["args"] =
        "templateType:feedback_form,status:active";
      this.currentData.templatedatasource["filter"] =
        "templateType:feedback_form,status:active,patientType.id:OP";
    } else if (this.input && this.input == "mis_ip_feedback_report") {
      this.currentData.templatedatasource = {
        application: "form-template-engine",
        resource: "template",
        query_id: "GET_SYSTEM_TEMPLATE_ACCOUNT_ID",
        filter: "templateType:feedback_form,status:active,patientType.id:IP",
      };
      this.currentData.template_key = "templateId";
      this.currentData.templatedatasource["args"] =
        "templateType:feedback_form,status:active";
      this.currentData.templatedatasource["filter"] =
        "templateType:feedback_form,status:active,patientType.id:IP";
    } else if (this.input && this.input == "mis_discharge_feedback_report") {
      this.currentData.templatedatasource = {
        application: "form-template-engine",
        resource: "template",
        query_id: "GET_SYSTEM_TEMPLATE_ACCOUNT_ID",
        filter: "templateType:feedback_form,status:active,patientType.id:IP",
      };
      this.currentData.template_key = "templateId";
      this.currentData.templatedatasource["args"] =
        "templateType:feedback_form,status:active";
      this.currentData.templatedatasource["filter"] =
        "templateType:feedback_form,status:active,patientType.id:IP";
    } else if (this.input && this.input == "mis_dc_feedback_report") {
      this.currentData.templatedatasource = {
        application: "form-template-engine",
        resource: "template",
        query_id: "GET_SYSTEM_TEMPLATE_ACCOUNT_ID",
        filter: "templateType:feedback_form,status:active,patientType.id:DC",
      };
      this.currentData.template_key = "templateId";
      this.currentData.templatedatasource["args"] =
        "templateType:feedback_form,status:active";
      this.currentData.templatedatasource["filter"] =
        "templateType:feedback_form,status:active,patientType.id:DC";
    } else if (this.input && this.input == "mis_er_feedback_report") {
      this.currentData.templatedatasource = {
        application: "form-template-engine",
        resource: "template",
        query_id: "GET_SYSTEM_TEMPLATE_ACCOUNT_ID",
        filter: "templateType:feedback_form,status:active,patientType.id:ER",
      };
      this.currentData.template_key = "templateId";
      this.currentData.templatedatasource["args"] =
        "templateType:feedback_form,status:active";
      this.currentData.templatedatasource["filter"] =
        "templateType:feedback_form,status:active,patientType.id:ER";
    } else if (this.input && this.input == "mis_admit_dc_feedback_report") {
      this.currentData.templatedatasource = {
        application: "form-template-engine",
        resource: "template",
        query_id: "GET_SYSTEM_TEMPLATE_ACCOUNT_ID",
        filter: "templateType:feedback_form,status:active,patientType.id:DC",
      };
      this.currentData.template_key = "templateId";
      this.currentData.templatedatasource["args"] =
        "templateType:feedback_form,status:active";
      this.currentData.templatedatasource["filter"] =
        "templateType:feedback_form,status:active,patientType.id:DC";
    } else if (this.input && this.input == "mis_admit_er_feedback_report") {
      this.currentData.templatedatasource = {
        application: "form-template-engine",
        resource: "template",
        query_id: "GET_SYSTEM_TEMPLATE_ACCOUNT_ID",
        filter: "templateType:feedback_form,status:active,patientType.id:ER",
      };
      this.currentData.template_key = "templateId";
      this.currentData.templatedatasource["args"] =
        "templateType:feedback_form,status:active";
      this.currentData.templatedatasource["filter"] =
        "templateType:feedback_form,status:active,patientType.id:ER";
    } else if (this.input && this.input == "mis_pathology_template_result_report") {
      this.currentData.templatedatasource = {
        application: "form-template-engine",
        resource: "template",
        query_id: "GET_ALL",
        filter: "templateType:diagnostic,status:active",
      };
      this.currentData.template_key = "templateId";
      this.currentData.templatedatasource["args"] =
        "serviceType_code:pathology,templateType:diagnostic,status:active";
      this.currentData.templatedatasource["filter"] =
        "serviceType:pathology,templateType:diagnostic,status:active";
    } else {
      this.currentData.templatedatasource = {
        application: "form-template-engine",
        resource: "template",
        query_id: "GET_SYSTEM_TEMPLATE_ACCOUNT_ID",
      };
      // this.currentData.templatedatasource = {
      //   "application": "form-template-engine",
      //   "resource": "template",
      //   "query_id": "GET_ALL_TEMPLATES_EXCEPT_TEMPLATE_ASSESSMENT"
      // }
      // this.currentData.templatedatasource['args'] = 'not_template_type:template_assessment';
      this.currentData.template_key = "templateId";
    }
    this.currentData.templatedefaultsetting = {
      singleSelection: true,
      allowSearchFilter: true,
      checkBoxRequired: false,
      closeDropDownOnSelection: true,
      apliCall: false,
      req_keys: "all",
    };
    this.currentData.templatequestion = new SearchAndSelect({
      datasource: this.currentData.templatedatasource,
      defaultsetting: this.currentData.templatedefaultsetting,
      getterKey: "id",
      getterValue: "name",
      options: true,
      req_keys: this.input && this.input == "template_mis"? ["id","name","templateType","form_template_id"] : "all",
    });
  }

  // initLayoutData(action?){
  //   super.initLayoutData(action);
  //   this._currentData.json = this.currentData.selected_data.text;
  //   this._currentData.resource = this.currentData.selected_data.text;
  //   this._currentData.resouceDef.resource = this.currentData.selected_data.text;
  // }

  onTemplateItemDeselect(event) {
    this._currentData.currentListComputedFields = undefined;
    console.log("Event is ", event);
  }

  onTemplateItemSelect(event) {
    if (this.currentData.see_data == undefined) {
      this.resourcename = this.input;
      super.ngOnInit();
    }
    this.currentData["fields"] = [];
    if (
      this._currentData.gridData &&
      this._currentData.gridData.filter &&
      this._currentData.gridData.filter.includes("templateId")
    ) {
      this._currentData.gridData.filter =
        this._currentData.gridData.filter.replace(
          "," +
            this.currentData.template_key +
            ":" +
            this.currentData.selected_data.id,
          ""
        );
    }
    if (this.currentData.selected_data != undefined) {
      this.currentData.see_data = true;
      this._currentData.currentListComputedFields = undefined;
      this.currentData.selected_data = event;
      this.computeFields();
    }
    this.currentData.selected_data = event;
    this.currentData.selectedTemplate = event.text;
    if (this.currentData.see_data) {
      this.bindGridFn();
    }
    // this._currentData.json = this.currentData.selected_data.text;
    // this._currentData.resource = this.currentData.selected_data.text;
  }

  getDataforUiEngine(resouceDef, callback) {
    this.currentData["fields"] = [];
    super.getDataforUiEngine(resouceDef, (callback) => {
      this.computeFields();
      this.bindGridFn();
    });
  }

  computeFields() {
    let resource;
    let dt;
    // if(this.input && this.input == 'health_assessment_mis'){
    //      resource =  "system_template"
    //      dt = {
    //       "query_id": "GET_BY_ID",
    //       "args": "id:" + this.currentData.selected_data.id
    //     }
    // }
    // else{
    //   resource =  "template"
    //   dt = {
    //    "query_id": "GET_TEMPLATE_FORM_BY_ID",
    //    "args": "id:" + this.currentData.selected_data.id
    //  }
    // }
    resource = "template";
    dt = {
      query_id: "GET_TEMPLATE_FORM_BY_ID",
      args: "id:" + this.currentData.selected_data.id,
    };
    this.baseService
      .getData(dt, "", resource, "form-template-engine")
      .subscribe((data: any) => {
        if (
          data.errCode == 0 &&
          data.resource &&
          data.resource.length > 0 &&
          data.resource[0].blocks &&
          data.resource[0].blocks.length > 0
        ) {
          this.currentData["form"] = data.resource[0].blocks;
          this.currentData["fields"] =
            this.currentData["fields"] != undefined
              ? this.currentData["fields"]
              : [];
          this.currentData["form"].forEach((element) => {
            element.fields = JSON.parse(JSON.stringify(element.fields));
            element.fields.forEach((elementOne) => {
              if (this._currentData.resouceDef.config.diagnostic_data){
                elementOne.name = elementOne.label;
              }
              let obj = {
                isFrontend: true,
                name: "component." + elementOne.name,
                heading: elementOne.label,
                component:
                  elementOne.component != undefined ? elementOne.component : "",
              };
              switch (elementOne.component) {
                case "numberbox":
                  if (
                    elementOne.class_conditions != undefined &&
                    elementOne.class_conditions.length > 0
                  ) {
                    obj["grid_color_text"] = true;
                    elementOne.class_conditions.forEach((class_conditions) => {
                      class_conditions["expression"] =
                        "item['" +
                        elementOne.name +
                        "']" +
                        (class_conditions.expression != undefined
                          ? class_conditions.expression
                          : "");
                    });
                    obj["class_conditions"] = elementOne.class_conditions;
                  }
                  obj["type"] = "composite";
                  obj["format"] =
                    "fn=function(item){let a= item.component.find(val => {return val.name == '" +
                    elementOne.name +
                    "'}); return a.valueString }";
                  break;
                case "dynamic-table":
                  obj["type"] = "composite";
                  obj["format"] =
                    "fn=function(item){let a= item.component.find(val => {return val.name == '" +
                    elementOne.name +
                    "'}); let f= a.valueString; let r = JSON.parse(f); return JSON.stringify(r.tableVal); }";
                  break;
                case "daterangepicker":
                  
                  obj["type"] = "composite";
                 
                  if (elementOne.timePicker == false) {
                    console.log("inside time picker false");
                    // obj['format'] =  "fn=function(item){let a= item.component.find(val => {return val.name == '" + elementOne.name + "'}); return new Date(parseInt(a.valueString)).toLocaleDateString();";
                    obj["format"] =
                      "fn=function(item){ " +
                      "let a = item.component.find(val => val.name == '" + elementOne.name + "'); " +
                      "let val = a.valueString; " +
                      "if(!isNaN(val)) { " +
                      "  return new Date(parseInt(val)).toLocaleDateString(); " +
                      "} " +
                      "return val; " +
                      "}";
                  } else if (elementOne.timePicker24Hour) {
                    obj["format"] =
                      "fn=function(item){ " +
                      "let a = item.component.find(val => val.name == '" + elementOne.name + "'); " +
                      "let val = a.valueString; " +
                      "if(!isNaN(val)) { " +
                      "  return new Date(parseInt(val)).toLocaleDateString() + ', ' + d.toLocaleTimeString([], { hour12: false, hour: '2-digit', minute: '2-digit' }); " +
                      "} " +
                      "return val; " +
                      "}";
                  } else {
                    obj["format"] =
                      "fn=function(item){ " +
                      "let a = item.component.find(val => val.name == '" + elementOne.name + "'); " +
                      "let val = a.valueString; " +
                      "if(!a || !a.valueString) return ''; " +
                      "if(!isNaN(val)) { " +
                      "  return new Date(parseInt(val)).toLocaleDateString() + ',' + new Date(parseInt(val)).toLocaleTimeString([], {timeStyle: 'short'}) " +
                      "} " +
                      "return val; " +
                      "}";
                  }

                  break;
                case "searchselect":
                  if (
                    elementOne.type &&
                    elementOne.type.toLowerCase() == "string"
                  ) {
                    obj["format"] =
                      "fn=function(item){let a= item.component.find(val => {return val.name == '" +
                      elementOne.name +
                      "'}); return a.valueString }";
                  } else {
                    obj["format"] =
                      "fn=function(item){let a= item.component.find(val => {return val.name == '" +
                      elementOne.name +
                      "'}); return a.valueString }";
                    // obj['type'] = "array";
                    // obj['format'] = "fn=function(item){return item.text}";
                  }
                  obj["type"] = "composite";
                  break;
                case "timepicker":
                  // obj['type'] = 'composite';
                  // obj['format'] = "fn=function(item){let a= item.component.find(val => {return val.name == '" + elementOne.name + "'}); return (new Date(parseInt(a.valueString)).toLocaleTimeString([], {timeStyle: 'short'}) }";
                  obj["type"] = "composite";
                  if (elementOne.timePicker24Hour == false) {
                    console.log("inside time picker12Hour ");
                    // obj['format'] =  "fn=function(item){let a= item.component.find(val => {return val.name == '" + elementOne.name + "'}); return new Date(parseInt(a.valueString)).toLocaleDateString();";
                    obj["format"] = `fn=function(item){
  let a = item.component.find(val => val.name == '${elementOne.name}');
  return (new Date(parseInt(a.valueString))).toLocaleTimeString([], {timeStyle: 'short'});
}`;
                  } else {
                    obj["format"] = `fn=function(item){
  let a = item.component.find(val => val.name == '${elementOne.name}');
  return (new Date(parseInt(a.valueString))).toLocaleTimeString([], { hour12: false, hour: '2-digit', minute: '2-digit' });
}`;
                  }

                  break;
                case "monthYearPicker":
                  obj["type"] = "composite";
                  obj["format"] =
                    "fn=function(item){let a= item.component.find(val => {return val.name == '" +
                    elementOne.name +
                    "'}); return (a.valueString!='null' && a.valueString!=null && a.valueString!=undefined) ? ('0' + (new Date(parseInt(a.valueString)).getMonth() + 1).toString()).slice(-2) + '/' + new Date(parseInt(a.valueString)).getFullYear().toString() : ''}";

                  break;
                case "html-editor":
                  obj["format"] =
                    "fn=function(item){let a= item.component.find(val => {return val.name == '" +
                    elementOne.name +
                    "'}); return a.valueString }";
                  obj["type"] = "composite";
                  break;
                case "checkbox":
                  if (
                    elementOne.type &&
                    elementOne.type.toLowerCase() == "array"
                  ) {
                    obj["format"] =
                      "fn=function(item){let a= item.component.find(val => {return val.name == '" +
                      elementOne.name +
                      "'}); if(typeof (a.valueString) == 'string') try{return JSON.parse(a.valueString).join(', ');} catch(error){return a.valueString}}";
                  } else {
                    obj["format"] =
                      "fn=function(item){let a= item.component.find(val => {return val.name == '" +
                      elementOne.name +
                      "'}); return (a.valueString == true || a.valueString == 'true')?'Yes':(a.valueString == false || a.valueString == 'false')?'No':a.valueString; }";
                  }
                  obj["type"] = "composite";
                  break;
                case "pullable":
                case "pushable":
                  if (
                    (elementOne.pullableData &&
                      elementOne.pullableData.resource) ||
                    (elementOne.pushable_master &&
                      elementOne.pushable_master.frontend_resource)
                  )
                    var resource =
                      elementOne.component == "pullable"
                        ? elementOne.pullableData.resource
                        : elementOne.pushable_master.frontend_resource;
                  obj["type"] = "composite";
                  //for type array
                  if (
                    resource == "condition_diagnosis_main" ||
                    resource == "condition_chief_complaint" ||
                    resource == "family_history" ||
                    resource == "social_history"
                  )
                    obj["format"] =
                      "fn=function(item){let a= item.component.find(val => {return val.name == '" +
                      elementOne.name +
                      "'}); var str=[]; var arr = JSON.parse(a.valueString); for(let i=0;i < arr.length;i++){var arr1 = []; if(arr[i].diagnosis){arr1 = arr[i].diagnosis;}else if(arr[i].chiefcomplaint){arr1 = arr[i].chiefcomplaint;}else if(arr[i].diseases){arr1 = arr[i].diseases;}else if(arr[i].proportion){arr1 = arr[i].proportion;} for(let j=0;j<arr1.length;j++){ str.push(arr1[j].text)}} return str.join(', ');}";
                  //for single key
                  else if (
                    resource == "allergy_intolerance_main" ||
                    resource == "service_request" ||
                    resource == "pushable_clinical_order" ||
                    resource == "medicationOrderDetails" ||
                    resource == "pushable_medication_order" ||
                    resource == "care_plan" ||
                    resource == "gynec_history" ||
                    resource == "travel_history" ||
                    resource == "past_surgical_history" ||
                    resource == "past_medical_history" ||
                    resource == "pushable_surgery_request" ||
                    resource == "pushable_package_request" ||
                    resource == "pushable_cathlab_surgery_request" ||
                    resource == "self_note" ||
                    resource == "insertion_details" ||
                    resource == "pain_assessment" ||
                    resource == "emr_refer" ||
                    resource == "task"
                  )
                    obj["format"] =
                      "fn=function(item){let a= item.component.find(val => {return val.name == '" +
                      elementOne.name +
                      "'}); var str=[]; var arr = JSON.parse(a.valueString); for(let i=0;i < arr.length;i++){ var key = ''; if(arr[i].substance){key = arr[i].substance;}else if(arr[i].serviceItemName){key = arr[i].serviceItemName;}else if(arr[i].itemName){key = arr[i].itemName;}else if(arr[i].problem){key = arr[i].problem;} else if(arr[i].hypertensiveProblems){key = arr[i].hypertensiveProblems;}else if(arr[i].travelled_place){key = arr[i].travelled_place;}else if(arr[i].surgeryName){key = arr[i].surgeryName;}else if(arr[i].illness){key = arr[i].illness;}else if(arr[i].surgery_package_name){key = arr[i].surgery_package_name;}else if(arr[i].note){key = arr[i].note;}else if(arr[i].type_of_insertion_id){key = arr[i].type_of_insertion_id;}else if(arr[i].pain_type_id){key = arr[i].pain_type_id;}else if(arr[i].referSpeciality || arr[i].referDoctor){key = arr[i].referDoctor!=undefined && arr[i].referDoctor!='' ? arr[i].referDoctor:arr[i].referSpeciality;}else if(arr[i].selectTask_id){key = arr[i].selectTask_id;} if(key){str.push(key);}} return str.join(', ');}";
                  else if (
                    resource == "diet_planDefinition" ||
                    resource == "sexual_history"
                  )
                    obj["format"] =
                      "fn=function(item){let a= item.component.find(val => {return val.name == '" +
                      elementOne.name +
                      "'}); var str=[]; var arr = JSON.parse(a.valueString); for(let i=0;i < arr.length;i++){ var key = ''; if(arr[i].dietType){key = arr[i].dietType;}else if(arr[i].gender){key = arr[i].gender;}if(key) {str.push(key);}} return str.join(', ');}";
                  //diagnosic report pullable
                  else if (resource == "observation")
                    obj["format"] =
                      "fn=function(item){let a= item.component.find(val => {return val.name == '" +
                      elementOne.name +
                      "'}); var str=[]; var arr = JSON.parse(a.valueString); for(let i=0;i < arr.length;i++){ if(arr[i].serviceItemName) {str.push(arr[i].serviceItemName);}} return str.join(', ');}";
                  else if (resource == "observation_vitals" || resource == "app-vitals-view")
                    obj["format"] =
                      "fn=function(item){let a= item.component.find(val => {return val.name == '" +
                      elementOne.name +
                      "'}); var data = JSON.parse(a.valueString); let arr = data && Array.isArray(data.vitalsName) ? data.vitalsName : Array.isArray(data) ? data : []; return arr.map(item => `${item.name}: ${item.value}`).join(', ');}";
                  else
                    obj["format"] =
                      "fn=function(item){let a= item.component.find(val => {return val.name == '" +
                      elementOne.name +
                      "'}); return a.valueString }";
                  break;
                default:
                  obj["type"] = "composite";
                  obj["format"] =
                    "fn=function(item){let a= item.component.find(val => {return val.name == '" +
                    elementOne.name +
                    "'}); return a.valueString }";
                  break;
              }
              if (obj.component == "subHeading") {
                //Nothing to do
              } else if (obj.component != "hidden")
                this.currentData["fields"].push(obj);
              //123027 & 142711(show final score of score component after score data)
              if (obj.component == "score") {
                let scoreObj = {
                  isFrontend: true,
                  name: "component." + elementOne.name + "final_score",
                  heading: elementOne.label + " - Final Score",
                  component:
                    elementOne.component != undefined
                      ? elementOne.component
                      : "",
                };
                scoreObj["type"] = "composite";
                scoreObj["format"] =
                  "fn=function(item){let a= item.component.find(val => {return val.name == '" +
                  elementOne.name +
                  "'}); let f= a.valueString; let r = JSON.parse(f); if(r.scoreField != undefined) {return ((r.riskLevel != undefined && r.riskLevel != '')?(r.scoreSum+ ' : ' +r.riskLevel):r.scoreSum)}else return ''; }";
                this.currentData["fields"].push(scoreObj);
              }
            });
          });
          this._currentData.currentListComputedFields = [
            ...this._currentData.currentListFields,
            ...this.currentData["fields"],
          ];
        } else {
          this._currentData.currentListComputedFields =
            this._currentData.currentListFields;
        }
        let index = this._currentData.currentListComputedFields.findIndex(
          (data) => data.name == "tag_data"
        );
        this._currentData.currentListComputedFields.splice(
          this._currentData.currentListComputedFields.length,
          0,
          this._currentData.currentListComputedFields.splice(index, 1)[0]
        );
        this._currentData.currentListComputedFields.push({
          heading: "",
          name: "",
          order: this._currentData.currentListComputedFields.length + 2,
          sortable: false,
          config: {
            type: "ellipse",
            buttonMenu: [],
          },
        });
      });
  }

  bindGrid(
    resource?,
    application?,
    type?,
    queryId?,
    printInfo?,
    callback = null
  ) {
    if (
      this._currentData.dataGridConfig &&
      this._currentData.dataGridConfig.complex_search == undefined
    )
      this._currentData.dataGridConfig.hideSearchBox = true;
    this._currentData.resouceDef.list.APIresource.args =
      this.currentData.template_key + ":" + this.currentData.selected_data.id;
    this._currentData.resouceDef.list.APIresource.filter =
      this.currentData.template_key + ":" + this.currentData.selected_data.id;
    this._currentData.gridData.args =
      this.currentData.template_key + ":" + this.currentData.selected_data.id;
    if (this._currentData.currentResource == "mis_er_feedback_report") {
      if (this._currentData.gridData.filter)
        this._currentData.gridData.filter +=
          "," +
          this.currentData.template_key +
          ":" +
          this.currentData.selected_data.id +
          "," +
          "patientType:ER" +
          ",status:Discharged";
    } else if (this._currentData.currentResource == "mis_dc_feedback_report") {
      if (this._currentData.gridData.filter)
        this._currentData.gridData.filter +=
          "," +
          this.currentData.template_key +
          ":" +
          this.currentData.selected_data.id +
          "," +
          "patientType:DC" +
          ",status:Discharged";
    } else if (this._currentData.currentResource == "mis_ip_feedback_report") {
      if (this._currentData.gridData.filter)
        this._currentData.gridData.filter +=
          "," +
          this.currentData.template_key +
          ":" +
          this.currentData.selected_data.id +
          "," +
          "patientType:IP";
    } else if (this._currentData.currentResource == "mis_op_feedback_report") {
      if (this._currentData.gridData.filter)
        this._currentData.gridData.filter +=
          "," +
          this.currentData.template_key +
          ":" +
          this.currentData.selected_data.id +
          "," +
          "patientType:OP";
    } else if (
      this._currentData.currentResource == "mis_discharge_feedback_report"
    ) {
      if (this._currentData.gridData.filter)
        this._currentData.gridData.filter +=
          "," +
          this.currentData.template_key +
          ":" +
          this.currentData.selected_data.id +
          "," +
          "patientType:IP,status:Discharged";
    } else if (this._currentData.currentResource == "mis_pathology_template_result_report") {
      if (this._currentData.gridData.args)
        this._currentData.gridData.args +=",serviceType_code:pathology";
      if (this._currentData.gridData.filter)
        this._currentData.gridData.filter +=",templateId:"+this.currentData.selected_data.id;
    } else if (this._currentData.currentResource == "mis_admit_er_feedback_report") {
      if (this._currentData.gridData.filter)
        this._currentData.gridData.filter +=
          "," +
          this.currentData.template_key +
          ":" +
          this.currentData.selected_data.id +
          "," +
          "patientType:ER" +
          ",status:Admitted#Discharge-Initiated";
    } else if (this._currentData.currentResource == "mis_admit_dc_feedback_report") {
      if (this._currentData.gridData.filter)
        this._currentData.gridData.filter +=
          "," +
          this.currentData.template_key +
          ":" +
          this.currentData.selected_data.id +
          "," +
          "patientType:DC" +
          ",status:Admitted#Discharge-Initiated";
    } else {
      if (this._currentData.gridData.filter)
        this._currentData.gridData.filter +=
          "," +
          this.currentData.template_key +
          ":" +
          this.currentData.selected_data.id +
          ",status:final";
    }
    if (this._currentData.gridData.filter.includes("FROM"))
      super.bindGrid(
        resource,
        application,
        type,
        queryId,
        printInfo,
        (callback) => {
          // if (callback && this._currentData.dataList != undefined && this._currentData.dataList.resource && this._currentData.dataList.resource.length > 0) {
          //   this._currentData.dataList.resource.forEach((e, index) => {
          //     var result = e.component.reduce(function (map, obj) {
          //       map[obj.name] = obj.valueString;
          //       return map;
          //     }, {});
          //     this._currentData.dataList.resource[index] = {...this._currentData.dataList.resource[index], ...result};
          //     // e = { ...e, ...result };
          //   });
          // }
          // this.loader.hideSpinner();
        }
      );
  }
}
